import i18next from 'i18next';
import { emailIsValid } from 'src/utils';
import * as Yup from 'yup';

const uploadSendDocsSchema = Yup.object().shape({
	enabled: Yup.boolean(),
	to: Yup.object().when('enabled', {
		is: true,
		then: (schema) =>
			schema
				.shape({
					value: Yup.string().required(i18next.t('required_field')),
					label: Yup.string().required(i18next.t('required_field')),
				})
				.required(i18next.t('required_field'))
				.test('valid-email', i18next.t('invalid_email'), (value) => {
					return value ? emailIsValid(value.value) : false;
				}),
		otherwise: (schema) => schema.nullable(),
	}),

	cc: Yup.array().of(
		Yup.object().shape({
			value: Yup.string().test(
				'valid-email',
				i18next.t('invalid_email'),
				(value) => (value ? emailIsValid(value) : true)
			),
		})
	),
	message: Yup.string().when('enabled', {
		is: true,
		then: (schema) => schema.required(i18next.t('required_field')),
		otherwise: (schema) => schema.notRequired(),
	}),
	files: Yup.array()
		.min(1, i18next.t('upload_file_required'))
		.required(i18next.t('required_field')),
});

export const VALIDATION = {
	uploadSendDocsSchema,
};
